<template>
	<Space v-bind="{ ...$attrs, ...$props }" direction="vertical" class="width-100">
		<slot></slot>
	</Space>
</template>

<script>
import { Space } from 'ant-design-vue';

// size: 'small', 'middle', 'large', Number

export default {
	components: {
		Space,
	},
}
</script>
